window.CKB_SEARCH_INDEX = (window.CKB_SEARCH_INDEX || []).concat([
  {
    "id": "CKC-MIL-2001",
    "title": "Military HF Field Systems: Mission-First Selection",
    "handle": "military-hf-field-systems",
    "quick": "Compare controlled Chameleon HF starting systems by mission, path, footprint, deployment time and evidence boundary—not by connector fit alone.",
    "summary": "Mission-first guidance for Army, Marine Corps, Navy shore and Seabee, Air Force, Space Force, Coast Guard, SOCOM-support and NATO partner-HQ planning.",
    "category": "Military and Government",
    "section": "Mission Planning",
    "keywords": "military HF government Army command post Marine expeditionary Navy shore Seabee Air Force bare base Space Force continuity Coast Guard SAR SOCOM support NATO partner HQ PACE beyond line of sight BLOS",
    "url": "/pages/military#mil-systems",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2002",
    "title": "CHA SKYLOOP 2.0 and SKYLOOP 40 for Fixed HF Sites",
    "handle": "military-skyloop-fixed-hf-sites",
    "quick": "Use the SKYLOOP family as a fixed or semi-fixed horizontal-loop starting point when the site can provide four supports, controlled geometry and adequate installation height.",
    "summary": "Compares the compact SKYLOOP 40 and larger SKYLOOP 2.0 footprints, including deployment advantages, site burden, low-height limitations and the ruggedized military wire path.",
    "category": "Military and Government",
    "section": "Fixed and Semi-Fixed HF",
    "keywords": "CHA SKYLOOP 2 SKY LOOP SKYLOOP40 sky loop 40 military base station HQ headquarters command post four support horizontal loop 14 AWG tinned copper PTFE Kevlar wire NATO Coast Guard Air Force Navy Seabee",
    "url": "/pages/military#mil-systems",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2003",
    "title": "CHA MPAS 2.0 with CHA MINI for Military HF",
    "handle": "military-mpas-2-mini",
    "quick": "MPAS 2.0 with the CHA MINI is the compact feed-unit path for rapid vertical or wire deployments; the exact radio, tuner, power, duty cycle and geometry still require approval.",
    "summary": "Explains the rapid-deployment advantages and the tuner, return-path, support, duty-cycle and mission-approval constraints of MPAS 2.0 with MINI.",
    "category": "Military and Government",
    "section": "Rapid Portable HF",
    "keywords": "CHA MPAS 2 MPAS2 CHA MINI military portable vertical wire antenna PACE alternate contingency emergency Army Marines SOCOM support NATO field radio tuner counterpoise",
    "url": "/pages/military#mil-systems",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2004",
    "title": "CHA NVIS Family for Regional Military HF",
    "handle": "military-nvis-regional-hf",
    "quick": "Use the CHA NVIS geometry as a regional-HF planning reference where near-vertical skywave coverage is intended and the operating frequency is selected from current ionospheric conditions.",
    "summary": "Covers regional-path strengths, the roughly 85-foot footprint, support and tuner requirements, frequency dependence and the boundary between civilian training equipment and a ruggedized military configuration.",
    "category": "Military and Government",
    "section": "Regional and NVIS HF",
    "keywords": "CHA NVIS near vertical incidence skywave regional HF regional communications military Army Marines Coast Guard emergency command post 15 foot mast 85 foot footprint ruggedized",
    "url": "/pages/military#mil-systems",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2005",
    "title": "CHA TD 2.0 and CHA HPD: Baseline versus Expanded System",
    "handle": "military-td-2-hpd-comparison",
    "quick": "CHA TD 2.0 is the complete baseline system. CHA HPD is not a stand-alone antenna; it adds two 108-foot wire assemblies for documented expanded geometries.",
    "summary": "A side-by-side civilian and military explanation of TD 2.0 alone versus TD 2.0 plus HPD, including 9 versus 15 documented paths, benefits, costs, space requirements and evidence limits.",
    "category": "Product Compatibility",
    "section": "CHA TD 2.0",
    "keywords": "CHA TD 2 TD2 tactical dipole CHA HPD high performance dipole add on addon expansion not standalone 9 configurations 15 configurations 108 foot wire pros cons military civilian counterpoise",
    "url": "/pages/military#mil-systems",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2006",
    "title": "CHA EMCOMM III BASE and PORTABLE for Continuity HF",
    "handle": "military-emcomm-iii-base-portable",
    "quick": "Compare the deliberate 130-foot EMCOMM III BASE system with the rapid 73-foot EMCOMM III PORTABLE geometry according to site, time, support and authorized radio chain.",
    "summary": "Explains fixed-site and portable continuity roles, documented wire geometries, deployment trade-offs and the required ruggedized acquisition path for operational military use.",
    "category": "Military and Government",
    "section": "Continuity and Emergency HF",
    "keywords": "CHA EMCOMM III BASE EMCOMM 3 base CHA EMCOMM III Portable EMCOMM 3 P portable military government continuity emergency HF command post HQ PACE 130 foot 73 foot ruggedized",
    "url": "/pages/military#mil-systems",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2007",
    "title": "CHA TDL Tactical Delta Loop for Rapid Field HF",
    "handle": "military-cha-tdl-field-hf",
    "quick": "Compare the CHA TDL inverted delta loop, vertical, horizontal NVIS dipole, and V-dipole configurations as distinct controlled field geometries.",
    "summary": "Mission-first guidance for the CHA TDL complete field system, including deployment speed, configuration choices, power boundaries, and representative 2D and interactive 3D NEC evidence.",
    "category": "Military and Government",
    "section": "Rapid Portable HF",
    "keywords": "CHA TDL tactical delta loop inverted delta vertical horizontal dipole NVIS V dipole two SS17 whips 25 foot loop military field antenna NEC 3D",
    "url": "/pages/military#mil-tdl",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2008",
    "title": "CHA MPAS Lite for Lightweight Modular Field HF",
    "handle": "military-cha-mpas-lite-field-hf",
    "quick": "Use CHA MPAS Lite when a lightweight kit and rapid transition among SS17 vertical, end-fed inverted-V, sloper, and horizontal NVIS geometries matter.",
    "summary": "Covers the approximately four-pound kit, documented geometry choices, low-band shortening boundary, signed counterpoise axis, and representative 2D and interactive 3D NEC evidence.",
    "category": "Military and Government",
    "section": "Rapid Portable HF",
    "keywords": "CHA MPAS Lite lightweight modular portable antenna SS17 vertical counterpoise end fed inverted V sloper horizontal NVIS military field HF NEC 3D",
    "url": "/pages/military#mil-mpas-lite",
    "published": true,
    "editorialStatus": "source_governed"
  },
  {
    "id": "CKC-MIL-2009",
    "title": "CHA LEFS 8010 Lightweight End-Fed Field System",
    "handle": "military-cha-lefs-8010-field-hf",
    "quick": "Evaluate the CHA LEFS 8010 standard 63-foot and extended 130-foot radiators for documented sloper and horizontal NVIS field geometries.",
    "summary": "Explains the documented band set, 80-meter extension requirement, support burden, power boundaries, and representative 2D and interactive 3D NEC evidence with its coil-geometry limitation.",
    "category": "Military and Government",
    "section": "Lightweight Field Wire",
    "keywords": "CHA LEFS 8010 lightweight end fed half wave EFHW 63 foot 130 foot 80 meter extension sloper horizontal NVIS military field HF NEC 3D",
    "url": "/pages/military#mil-lefs8010",
    "published": true,
    "editorialStatus": "source_governed"
  }
]);
